var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "incident-management-report",
      "data-test": "outside-vif"
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-container', {
    staticClass: "raft-charts-wrapper"
  }, [_c('TotalReportsByAreaType', {
    staticClass: "raft-chart",
    attrs: {
      "id": "reports-by-area-type",
      "chart-title": "Reports by Area Type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid--2 view-content"
  }, [_c('div', {
    staticClass: "views-row"
  }, [_c('OpenReportsByStatus', {
    staticClass: "raft-chart",
    attrs: {
      "id": "open-reports-by-status",
      "chart-title": "Open Reports by Status",
      "chart-width": "50%"
    }
  }), _vm._v(" "), _c('ReportsByReportType', {
    staticClass: "raft-chart",
    attrs: {
      "id": "reports-by-report-type",
      "chart-title": "Reports By Report Type",
      "chart-height": "100%"
    }
  })], 1)]), _vm._v(" "), _c('OpenReportsByDepartment', {
    staticClass: "raft-chart",
    attrs: {
      "id": "open-reports-by-department",
      "chart-title": "Open Reports by Department/Unit"
    }
  }), _vm._v(" "), _c('ReportsByDepartmentYear', {
    staticClass: "raft-chart",
    attrs: {
      "id": "open-reports-by-department-year",
      "chart-title": "Reports in the Last Year by Department/Unit"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form', [_c('fieldset', {
    staticClass: "incident-report-listing-filters"
  }, [_c('legend', [_vm._v("Incident Report Summary")]), _vm._v(" "), _c('b-container', [_c('b-row', [_c('b-col', {
    staticClass: "raft-js-filter-cols datefilter-wrapper-col"
  }, [_c('date-filter', {
    attrs: {
      "date-between": true,
      "get-value": _vm.reportedAfterDate,
      "update-method": _vm.updateDateBetweenStart,
      "end-date-get-value": _vm.reportedBeforeDate,
      "end-date-update-method": _vm.updateDateBetweenEnd,
      "label": "Reported After",
      "end-label": "Reported Before",
      "id": "date-filter"
    }
  })], 1)], 1)], 1), _vm._v(" "), !_vm.isBusy ? _c('b-table', {
    ref: "table",
    staticClass: "incident-management-report",
    attrs: {
      "striped": "",
      "hover": "",
      "show-empty": "",
      "id": "incident-management-report",
      "fields": _vm.fields,
      "items": _vm.items
    },
    scopedSlots: _vm._u([{
      key: "cell(value)",
      fn: function (data) {
        return [data.item.field === 'near_misses' ? _c('div', [_c('b-link', {
          attrs: {
            "href": '/raft/incident-management/incident-reports?reportTypeFilter=near_miss'
          }
        }, [_vm._v("\n              " + _vm._s(data.item.value) + "\n            ")])], 1) : data.item.field === 'incident_reports' ? _c('div', [_c('b-link', {
          attrs: {
            "href": '/raft/incident-management/incident-reports?reportTypeFilter=incident_report'
          }
        }, [_vm._v("\n              " + _vm._s(data.item.value) + "\n            ")])], 1) : data.item.field === 'open_reports' ? _c('div', [_c('b-link', {
          attrs: {
            "href": '/raft/incident-management/incident-reports?statusFilter=in_progress&statusFilter=collecting_details&statusFilter=submitted'
          }
        }, [_vm._v("\n              " + _vm._s(data.item.value) + "\n            ")])], 1) : _c('div', [_c('b-link', {
          attrs: {
            "href": '/raft/incident-management/incident-reports'
          }
        }, [_vm._v("\n              " + _vm._s(data.item.value) + "\n            ")])], 1)];
      }
    }, {
      key: "empty",
      fn: function () {
        return [_c('ErrorStateLinks')];
      },
      proxy: true
    }], null, false, 1455365201)
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "busy-wrapper"
  }, [_vm.isBusy ? _c('raft-busy', {
    attrs: {
      "busy-text": "Loading..."
    }
  }) : _vm._e()], 1)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }